export default __webpack_public_path__ + "img/landscape_1.353e234c991d5bd378b0e1412bb36e00.jpg";